import { lifecycle } from 'recompose';

const withLifeCycle = {
    componentDidUpdate(prevProps) {
    }
};

export default lifecycle(withLifeCycle);